/**
 * 缓动动画 页面跳转到指定位置
 * Created by liuxsen on 2017/4/7.
 */
function install(Vue) {
  //获得元素的位置
  function getElementTop(element) {
    return element.offsetTop;
  };
  Vue.prototype.getElementTop = function (element){
    return element.offsetTop;
  };
  //获得滚动的长度
  Vue.prototype.$getScrollOffsets = function (_w) {
    _w = _w || window;
    //for all and IE9+
    if (_w.pageXOffset != null) return {
      x: _w.pageXOffset,
      y: _w.pageYOffset
    };
    //for IE678
    let _d = _w.document;
    if (document.compatMode == "CSS1Compat") return { //for IE678
      x: _d.documentElement.scrollLeft,
      y: _d.documentElement.scrollTop
    };
    //for other mode
    return {
      x: _d.body.scrollLeft,
      y: _d.body.scrpllTop
    };
  };
  //获得视口的大小
  Vue.prototype.$getViewPortSize = function (_w) {//获取页面的窗口大小
    _w = _w || window;
    //for all and IE9+
    if (_w.innerWidth != null) return {
      x: _w.innerWidth,
      y: _w.innerHeight
    };
    //for IE678
    let _d = _w.document;
    if (document.compatMode == "CSS1Compat") return { //for IE678
      x: _d.documentElement.clientWidth,
      y: _d.documentElement.clientHeight
    };
    //for other mode
    return {
      x: _d.body.clientWidth,
      y: _d.body.clientHeight
    };
  };
  Vue.prototype.$toPosition = function (_obj) {
    let targetX, targetY;
    if (!_obj) { //如果不指定锚点元素，就跳到页面顶端0，0位置
      targetX = 0;
      targetY = 0;
    } else {
      if (typeof (_obj) == "string") {
        _obj = document.getElementById(_obj);
      } else {
        _obj = _obj
      }
      targetX = _obj.getBoundingClientRect().left + this.$getScrollOffsets().x;
      targetY = _obj.getBoundingClientRect().top + this.$getScrollOffsets().y;
    }

    //如果目标元素的位置在最后一屏，那就指定目标位置为页面底部
    //如果目标元素的位置为负数，就指定目标位置为页面顶部
    let maxTargetX = document.body.scrollWidth - this.$getViewPortSize().x;
    if (targetX >= maxTargetX) targetX = maxTargetX;
    if (targetX < 0) targetX = 0;
    let maxTargetY = document.body.scrollHeight - this.$getViewPortSize().y;
    if (targetY >= maxTargetY) targetY = maxTargetY;
    if (targetY < 0) targetY = 0;
    let _self = this;
    let tempTimer = setInterval(function () {
      let currentY = _self.$getScrollOffsets().y;
      let currentX = _self.$getScrollOffsets().x;
      //跳转位置的缓冲公式
      let tempTargetY = currentY - (currentY - targetY) / 10;
      let tempTargetX = currentX - (currentX - targetX) / 10;
      //由于缓冲公式会生成小数，而scrollTo函数会省略小数点后面的数字，所以要对跳转的坐标做一些微调
      if (Math.abs(tempTargetY - currentY) < 1) {
        tempTargetY - currentY > 0 ? tempTargetY++ : tempTargetY--;
      }
      if (Math.abs(tempTargetX - currentX) < 1) {
        tempTargetX - currentX > 0 ? tempTargetX++ : tempTargetX--;
      }
      //页面跳转
      window.scrollTo(tempTargetX, tempTargetY);
      //到达指定位置后清除一下Interval
      if (Math.abs(_self.$getScrollOffsets().y - targetY) <= 2 && Math.abs(_self.$getScrollOffsets().x - targetX) <= 2) {
        clearInterval(tempTimer);
        window.scrollTo(targetX, targetY);
        //console.log("done");
      }
    }, 10);

  },
    //添加全局的指令
    Vue.directive('to-positon', {
      inserted(el, binding, vnode, oldVnode){
        let startTop = getElementTop(el)
        window.addEventListener('scroll', () => {
          let docHeight = document.documentElement.clientWidth || document.body.clientHeight;
          let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
          let elementTop = getElementTop(el);
          if (scrollTop >= startTop) {
            let oldClass = el.getAttribute('class');
            let newClassArr = oldClass.split(" ");
            if (newClassArr.indexOf('fix') == -1) {
              newClassArr.push('fix');
            }
            let newClass = newClassArr.join(' ');
            el.setAttribute("class", newClass);
          } else {
            var oldClass = el.getAttribute('class');
            var newClassArr = oldClass.split(" ");
            // el.setAttribute("class",newClass);
            if(oldClass.indexOf('fix') !==-1){
              newClassArr.splice(newClassArr.indexOf('fix'), 1);
              console.log(newClassArr);
              let newClass = newClassArr.join(" ");
              el.setAttribute("class", newClass);
            }
          }
        })
      },
      update: function () {
        console.log('update')
      },
    })
}

export default install;



// WEBPACK FOOTER //
// ./src/plugin/toPosition.js